export default __webpack_public_path__ + "static/media/digital-transformation.9df911c3.png";